import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CardImageFooterA from 'components/CardImageFooter/CardImageFooterA';
import { isEmpty } from 'lodash';
import classes from './CardImageA.module.scss';

const CardImageA = (props) => {
  const {
    listType,
    heading,
    contentMarkup,
    imageURI,
    imageAltText = '',
    imageLink = {},
    buttons = [],
    links = [],
    imageHeight,
    imageWidth,
  } = props;

  const footerChildren = listType === 'Links' ? links : buttons;

  const image = (
    <img
      className={classes.image}
      src={imageURI}
      alt={imageAltText}
      width={imageWidth}
      height={imageHeight}
      loading='lazy'
      aria-hidden
    />
  );

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <div className={classes.imageContainer}>
          {imageURI && (!isEmpty(imageLink)
            ? (
              <a
                aria-label={heading}
                href={imageLink.href}
                target={imageLink.target}
                className={classNames({ [classes.unlink]: !imageLink.href })}
              >
                {image}
              </a>)
            : image
          )}
        </div>
        <div className={classes.infoContainer}>
          {heading &&
          <h2
            className={classes.heading}
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
          {contentMarkup &&
          <div
            className={classes.contentMarkup}
            dangerouslySetInnerHTML={{ __html: contentMarkup }}
          />}
          <CardImageFooterA
            classes={classes}
            footerChildren={footerChildren}
            containerKey='CardImageA-footerChildren'
          />
        </div>
      </div>
    </div>
  );
};

CardImageA.propTypes = {
  /**
    * Type of list<br>
    * Options: `Buttons` `Links`
  */
  listType: PropTypes.string,
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * Image URL
  */
  imageURI: PropTypes.string,
  /**
   * Image alternate text that displays on hover over of image
  */
  imageAltText: PropTypes.string,
  /**
   * Image Link Object
  */
  imageLink: PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    imageUrl: PropTypes.string,
    altText: PropTypes.string,
  }),
  /**
   * List of buttons<br>
   * Only used when `listType` = `Buttons`
  */
  buttons: PropTypes.array,
  /**
   * List of links<br>
   * Only used when `listType` = `Links`
  */
  links: PropTypes.array,
  /**
   * Pixel height of image
  */
  imageHeight: PropTypes.number,
  /**
   * Pixel width of image
  */
  imageWidth: PropTypes.number,
};

export default CardImageA;
